import { Button } from '@commenda/kakashi';

type CTA = {
  title: string;
  action: (() => void) | (() => Promise<void>);
};

const GenericErrorPage = ({
  title,
  message,
  primaryCTA,
  secondaryCTA,
}: {
  title: string;
  message: string;
  primaryCTA: CTA;
  secondaryCTA?: CTA;
}) => (
  <div className="w-full h-screen flex flex-col justify-center items-center bg-white overflow-hidden">
    <div className="flex h-full flex-col col-start-6 col-span-4 justify-center items-start gap-10 max-w-[620px]">
      <div className="flex flex-col gap-4 pb-6 border-b border-border-primary">
        <p className="text-text-primary display-xs-bold leading-loose">
          {title}
        </p>
        <p className="text-text-secondary txt-large-regular">{message}</p>
      </div>
      <div className="flex gap-2">
        <Button size="md" onClick={primaryCTA.action}>
          {' '}
          {primaryCTA.title}{' '}
        </Button>
        {secondaryCTA ? (
          <div className="flex flex-col gap-2">
            <Button variant="secondary" size="md" onClick={secondaryCTA.action}>
              {' '}
              {secondaryCTA.title}{' '}
            </Button>
          </div>
        ) : undefined}
      </div>
    </div>
  </div>
);

export default GenericErrorPage;
